import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import {Grid, Box, Button} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import Alert from '../components/Alert';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  paper: {
    fontSize: '12px !important',    
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const classes = useStyles();
  const [open, setOpen] = React.useState(false); 
  const childRefAlert = React.useRef(); 
  const [loadingBtn, setLoadingBtn] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");
  
  const [remarks, setRemarks] = React.useState("");
  //const [currentFileUrl, setCurrentFileUrl] = React.useState("");
  const [selectedFilePath, setSelectedFilePath] = React.useState("");
  const [currentFile, setCurrentFile] = React.useState("");
  const [ownerAlias, setOwnerAlias] = React.useState("");
  const [ownerId, setOwnerId] = React.useState(0);
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };


  React.useEffect(() => {	
    if(props.dataObj!=null && props.dataObj.autoId){      

      setRemarks(props.dataObj.description);
      setCurrentFile(props.dataObj.fileName); 
      setSelectedFilePath(props.dataObj.fileNameOriginal);
      setOwnerAlias(props.dataObj.ownerAlias);
      setOwnerId(props.dataObj.ownerId);


    }else{

      setRemarks("");
      setCurrentFile("");
      setSelectedFilePath("");

      if(props.userObj && props.userObj.fullName){
        setOwnerAlias(props.userObj.fullName);
        setOwnerId(props.userObj.userId);
      }else{
        setOwnerAlias("");
        setOwnerId(0);
      }
      
    }
    
    setLoadingBtn(false);

	}, [props.userObj,props.dataObj,open]);
  

	function saveData(){
    if(!selectedFilePath && !currentFile){
      setSeverityAlert("error");
      setAlertMessage("Browse file");	
      childRefAlert.current.handleClickOpen();		
      return false;
    }

		if(selectedFilePath || remarks){ 

			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      } 
      data.append('relatedTo', props.relatedTo);
      data.append('relatedToId', props.relatedToId);
      data.append('relatedTitle', props.relatedTitle);
      
      data.append('description', remarks);

      var browseFile = document.querySelector('#selectedFile');
      if(browseFile && browseFile.files[0] && browseFile.files[0].name.length>0){
        data.append("uploadedFiles", browseFile.files[0]);
      }

      data.append("currentFile", currentFile);

      data.append('ownerId', ownerId);
      data.append('ownerAlias', ownerAlias);
      
      let apiURL='/crm-create-files';
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-files';
      }
      
      setLoadingBtn(true);
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setLoadingBtn(false);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);					
					setAlertMessage("File has been saved.");
          childRefAlert.current.handleClickOpen();
          props.updatedList(response.data.list);
					return false;

				}else if(response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';

				}else{
          setSeverityAlert("error");					
					setAlertMessage("File could not be saved.");	
          childRefAlert.current.handleClickOpen();			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setAlertMessage(""+error);			
          childRefAlert.current.handleClickOpen();	
					return false;
			})	
		}		
	}


  
  return (
    <>
      <Dialog  maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{(props.dataObj!=null && props.dataObj.autoId)?<>Edit</>:<>New</>} File</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                              <input                             
                                className={classes.input}
                                style={{ display: 'none' }}
                                id="selectedFile"
                                type="file" 
                                onChange={event => setSelectedFilePath(event.target.value)}
                              /> 
                              <label htmlFor="selectedFile">
                            <Button component="span" style={{margin: 2}} size="small" variant="outlined" >
                              Browse File
                            </Button>   
                            {
                              (selectedFilePath && selectedFilePath.length>0 && selectedFilePath.split('\\')[2])?
                              <span style={{marginLeft:5}}>{selectedFilePath.split('\\')[2]}</span>
                              :(selectedFilePath && selectedFilePath.length>0)?<span style={{marginLeft:5}}>{selectedFilePath}</span>:null
                            }                         
                          </label>
                          </Grid>
                          <Grid item md={12} xs={12} >
                              <TextField label="Remarks" onChange={event => setRemarks(event.target.value)} value={remarks} fullWidth variant="outlined" multiline size="small" />
                          </Grid>                          


     
                    </Grid>

                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {loadingBtn?
                            <LoadingButton
                              loading
                              loadingPosition="start"											
                              variant="outlined"
                              color="secondary"
                              id="waitloginbtnid" 
                              style={{width: 110, backgroundColor:'#008000',color:'#FFF',marginRight:10}}
                            >
                              Wait...
                            </LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }    
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} /> 
        
    </>
  );

});

export default CustomizedDialogs;